import toastr from 'toastr';

toastr.options = {
    "closeButton": false,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "5000",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "5000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
}

window.toastr = toastr;

window.toastSuccess = toastSuccess;
window.toastError = toastError;
window.toastInfo = toastInfo;
window.toastWarning = toastWarning;
window.showCustomToast = showCustomToast

function toastSuccess(message) {
    window.toastr.success(message);
}

function toastError(message) {
    window.toastr.error(message);
}

function toastInfo(message) {
    window.toastr.info(message);
}

function toastWarning(message) {
    window.toastr.warning(message);
}

function showCustomToast(message) {
    // Öncekini kaldır
    let oldToast = document.querySelector('.custom-toast');
    if (oldToast) oldToast.remove();

    // Yeni toast div
    const toast = document.createElement('div');
    toast.classList.add('custom-toast');

    // Mesaj
    const msg = document.createElement('div');
    msg.innerText = message;

    // Kapatma butonu
    const closeBtn = document.createElement('span');
    closeBtn.innerHTML = "&times;";
    closeBtn.classList.add('close-btn');
    closeBtn.onclick = () => toast.remove();

    // Ekle
    toast.appendChild(closeBtn);
    toast.appendChild(msg);
    document.body.appendChild(toast);

    // Animasyonla göster
    setTimeout(() => {
        toast.classList.add('show');
    }, 50);
}


